import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { CreativeUploadPageContext } from './CreativeUpload.context'
import { CreativeUploadPageController } from './CreativeUpload.controller'
import { FC } from 'react'
import { useParams } from 'react-router-dom'

/**
 * Module providing CTs new flow for uploading visuals on separate page.  
 * Assignment id is sourced from address path param.  
 * @example <CreativeUploadPage />
 */
export const CreativeUploadPage: FC = () => {
  const { id } = useParams<{ id?: string }>()

  if (!id) return null

  return (
    <BKBNThemeWrapper>
      <CreativeUploadPageContext assignmentId={id}>
        <CreativeUploadPageController />
      </CreativeUploadPageContext>
    </BKBNThemeWrapper>
  )
}
